import { CatalogBuilder } from "../../../commonGroupModuleStructure/catalogBuilder";
import { deleteFeatureAccess, getFeatureAccessPaging } from "./apiCall";
import { FeaturesAccessKeys } from "./entity";

export const FeatureAccess = (props: any) => {
  const columns = [
    {
      field: "DisplayName",
      headerName: "Name",
      flex: 1,
      minWidth: 130,
      headerAlign: "left",
    },
    {
      field: "FeatureName",
      headerName: "Feature",
      flex: 1,
      minWidth: 130,
      headerAlign: "left",
    },
    {
      field: "Attribute",
      headerName: "Attribute",
      flex: 1,
      minWidth: 130,
      headerAlign: "left",
    },
  ];

  return (
    <CatalogBuilder
      headerLabel="Feature Access"
      headerButtonLabel="Add Feature Access"

      getPagingData={getFeatureAccessPaging}
      pagingAPIKey={FeaturesAccessKeys.paging}

      onDelete={deleteFeatureAccess}
      deletePagingAPIKey={FeaturesAccessKeys.delete}

      // pagingColumns={columns}
      onModeClickPath="/featureAccess/details/"
    />
  );
};
